import { Component, Input, OnInit } from '@angular/core';
import { ClaimRow } from '../../../../../models/api/view/claim-view/claim-row';
import { SharpData } from '../../../../../models/api/view/claim/details/workers-compensation/sharp-data';
import { BaseComponent } from '../../../../base/base.component';
import { CardComponent } from '../../../../core/panels/card.component';
import { DetailItemComponent } from '../../../../core/panels/detail-panel/detail-item.component';
import { DetailPanelComponent } from '../../../../core/panels/detail-panel/detail-panel.component';

@Component({
  selector: 'app-sharps-wc',
  imports: [DetailPanelComponent, DetailItemComponent, CardComponent],
  template: `
    @if (this.sharpData && this.sharpData.isFromCalifornia) {
      <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
        <app-card label="injury" class="tw-basis-3/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item
              label="SHARPS injury case"
              name="injuryCase"
              format="b"
              labelCase="none"
            />
            <app-detail-item
              label="Procedure being performed at time of injury"
              name="procedure"
            />
            <app-detail-item
              label="Describe how the incident occurred"
              labelPosition="Top"
              name="howOccurredCA"
            />
          </app-detail-panel>
        </app-card>

        <app-card label="sharp" class="tw-basis-2/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item label="Type" name="sharpType" />
            <app-detail-item label="Brand" name="brand" />
            <app-detail-item label="Model" name="model" />
          </app-detail-panel>
        </app-card>
      </div>

      <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
        <app-card label="injury protection" class="tw-basis-3/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item
              label="Did The device being used have engineered SHARPS injury protection?"
              name="protection"
              format="b"
            />
            <app-detail-item
              label="A) Was engineered SHARPS injury protection on the SHARP involved?"
              name="protectionInvolved"
              format="b"
              labelCase="none"
            />
            <app-detail-item
              label="B) Was the protective mechanism activated?"
              name="protectionActive"
              format="b"
              labelCase="none"
            />
            <app-detail-item
              label="C) The exposure incident occurred"
              name="exposureOccur"
              labelCase="none"
            />
          </app-detail-panel>
        </app-card>

        <app-card label="employee" class="tw-basis-2/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item
              label="Does the exposed employee believe that any controls could have prevented the injury"
              name="employeePrevent"
              format="b"
              classes="tw-flex-nowrap"
            />
            <app-detail-item
              label="Employee's opinion and comments on the exposure incident"
              name="employeeOpinion"
              classes="tw-flex-nowrap"
            />
          </app-detail-panel>
        </app-card>
      </div>
    }
    @if (this.sharpData && !this.sharpData.isFromCalifornia) {
      <div class="tw-flex tw-w-full tw-gap-8 tw-py-8">
        <app-card label="injury" class="tw-basis-3/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item
              label="SHARPS injury case"
              name="injuryCase"
              format="b"
              labelCase="none"
            />
            <app-detail-item
              label="Work area where injury occurred"
              name="caseLocation"
            />
            <app-detail-item
              label="Brief description of how injury occurred"
              name="howOccurred"
              labelPosition="Top"
            />
          </app-detail-panel>
        </app-card>

        <app-card label="sharp" class="tw-basis-2/5">
          <app-detail-panel [dataSource]="this.sharpData">
            <app-detail-item label="Type" name="sharpType" />
            <app-detail-item label="Brand" name="brand" />
          </app-detail-panel>
        </app-card>
      </div>
    }
  `,
  styles: ``,
})
export class SharpsWcComponent extends BaseComponent implements OnInit {
  claimRow: ClaimRow;
  @Input() sharpData: SharpData | null = null;

  ngOnInit(): void {
    this.view.hideLoading();
  }
}
